const ROOT = "fileUploadViewer";
const FILE_UPLOAD_NAME_CONTAINER = "fileUploadNameContainer";
const FILE_UPLOAD_NAME = "fileUploadName";
const FILE_UPLOAD_EXTENSION = "fileUploadExtension";

export { FILE_UPLOAD_EXTENSION, FILE_UPLOAD_NAME, FILE_UPLOAD_NAME_CONTAINER, ROOT };
//# sourceMappingURL=dataHooks.js.map
